import { createContext, useState, useCallback, useMemo } from "react";
import { getUseContext } from "common/utils";

const initialData = {
  state: {
    title: "타이틀",
    description: "내용",
    confirmText: "확인",
    cancelText: "취소",
    visible: false,
    visibleConfirm: true,
    visibleCancel: false,
  },
  action: {
    showAlert2: () => {},
    showConfirm2: () => {},
    confirm: () => {},
    cancel: () => {},
  },
  callback: {
    confirmHandler: () => {},
    cancelHandler: () => {},
  },
};

const PopAlert2Context = createContext();

function PopAlert2Provider({ children }) {
  const [state, setState] = useState(initialData.state);
  const [callback, setCallback] = useState(initialData.callback);
  const { confirmHandler, cancelHandler } = callback;

  const showAlert2 = useCallback(
    (title, description, handlers = {}, props = {}) => {
      setState(() => ({
        ...initialData.state,
        ...props,
        title,
        description,
        visible: true,
      }));
      setCallback(() => ({ ...initialData.callback, ...handlers }));
    },
    []
  );

  const showConfirm2 = useCallback(
    (title, description, handlers = {}, props = {}) => {
      setState(() => ({
        ...initialData.state,
        ...props,
        title,
        description,
        visible: true,
        visibleCancel: true,
      }));
      setCallback(() => ({ ...initialData.callback, ...handlers }));
    },
    []
  );

  const hideAlert = useCallback(() => {
    setState(initialData.state);
  }, []);

  const confirm = useCallback(() => {
    setState(() => initialData.state);
    if (confirmHandler && typeof confirmHandler === "function") {
      confirmHandler();
      setCallback(() => initialData.callback);
    }
  }, [confirmHandler]);

  const cancel = useCallback(() => {
    setState(() => initialData.state);
    if (cancelHandler && typeof cancelHandler === "function") {
      cancelHandler();
      setCallback(() => initialData.callback);
    }
  }, [cancelHandler]);

  const value = {
    state,
    action: { showAlert2, showConfirm2, confirm, cancel, hideAlert },
  };

  return (
    <PopAlert2Context.Provider value={value}>
      {children}
    </PopAlert2Context.Provider>
  );
}

export const usePopAlert2Context = () => getUseContext(PopAlert2Context);
export default PopAlert2Provider;
